var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "windOne"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.39,
    cy: 30.246,
    r: 29.946,
    style: {
      fill: "#0070ff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.692,36.768c-1.478,1.5 -2.713,2.446 -4.708,3.5",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.765,35.358c-0.287,0.322 -0.671,0.62 -1.08,0.821",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.422,17.014c1.641,4.267 1.808,9.034 -0.289,14.34",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.765,10.923c1.784,1.054 3.104,2.185 4.369,3.646",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.105,21.362c0.365,3.104 0.081,5.105 -0.987,7.893",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.395,13.664c2.207,1.464 3.743,2.847 5.06,5.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.971,24.184c1.292,-6.482 5.242,-11.142 12.727,-11.757",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.759,16.701c3.543,-5.114 7.593,-6.959 13.12,-7.124",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694,24.906c0.174,-2.019 0.676,-3.934 1.562,-5.828",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.214,51.968l1.311,-24.163l2.724,-0.004l1.222,24.245",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.842,
    cy: 25.484,
    rx: 2.287,
    ry: 2.316,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.777,22.888l2.426,-12.191c0.248,-1.436 -1.689,-2.045 -2.18,-0.541l-3.926,11.452c-0.701,3.214 2.894,3.542 3.68,1.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.928,28.647l10.576,6.531c1.258,0.734 2.506,-0.869 1.268,-1.854l-9.361,-7.678c-2.767,-1.779 -4.329,1.475 -2.483,3.001Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.331,24.719l-12.092,2.88c-1.408,0.374 -1.154,2.388 0.418,2.207l12.046,-1.209c3.214,-0.703 2.012,-4.107 -0.372,-3.878Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.436,52.046l8.849,-0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindOne);
export default __webpack_public_path__ + "static/media/windOne.667c531d15b30a54dd9ef0bb9e7c56b7.svg";
export { ForwardRef as ReactComponent };